/**
 * English - `tipsQuestions`: the ⓘ explanations beside the product questions
 * screen's fields. One key per field, `<form>.<field>`, passed as the field's
 * `info`. Conventions: see `common.ts`.
 */
const tipsQuestions: Record<string, string> = {
  'list.search':
    'Type a few words from a question or an answer, or the name of the customer who asked, to find it in this tab.',
  'answer.answer':
    'Your answer to this question. Once published it shows under the question on the product page for every customer, and the person who asked is emailed it once if they left an email. Up to 2000 characters. Example: Yes, it is 100% cotton and machine washable.',
};

export default tipsQuestions;
